// frontend/admin-portal/src/components/settings/items/TextInput.jsx
import React from "react";
import { Input } from "@fiberhome/shared-ui";

export default function TextInput({
  value,
  onChange,
  placeholder,
  type = "text",
  disabled = false,
}) {
  const handle = (e) => {
    if (typeof onChange === "function") onChange(e.target.value);
  };
  return (
    <Input
      type={type}
      value={value ?? ""}
      onChange={handle}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={typeof onChange !== "function"}
    />
  );
}
